export const columns: string[] = ['name', 'realEstateAgents'];
